<template>
  <div
    class="vote-item p-4 relative flex flex-col"
    :class="{ 'show-pinned': !noPinnedHighlight && !!pinnedColor }"
  >
    <div
      v-if="this.voteItem.affair.peopleVote != 'no'"
      class="bg-color-user leading-none rounded-lg text-chplus-s text-white uppercase mb-2 text-left px-2 py-1"
    >
      <span class="font-bold">{{
        $t("components.tags.people_vote.label")
      }}</span>
      <span>{{
        $t(`components.tags.people_vote.${this.voteItem.affair.peopleVote}`)
      }}</span>
    </div>
    <div
      class="vote-item-user-vote mx-auto mb-2"
      v-if="voteItem.decision && candidateId"
      :style="{
        'background-color': this.userVote
          ? this.getVoteColor(this.userVote)
          : 'transparent',
        'border-radius': '1rem'
      }"
    >
      <vote-button
        style="border-color: white;"
        :decision="this.voteItem.decision"
        active
        disabled
      >
        {{ getVoteLabel(this.voteItem.decision) }}
      </vote-button>
    </div>
    <span>
      <pure-pin-button
        v-if="showPin || !!pinnedColor"
        :color="pinnedColor"
        @click="$emit('pinned')"
        class="absolute "
        style="top: 0.5rem; right: 0.5rem"
      />
    </span>

    <div
      class="vote-item-tags flex flex-wrap gap-2"
      @click="toggleVoteTagDisplay"
    >
      <vote-item-tag
        v-for="(topic, i) in voteItem.affair.topics"
        class="cursor-pointer"
        :inline="voteTagDisplay === 'inline'"
        :key="i"
        :topic="topic"
      />
    </div>
    <div
      class="cursor-pointer flex-grow flex flex-col justify-between"
      @click="$emit('text-click')"
    >
      <div>
        <div
          class="vote-item-title cut-paragraph-3 text-chplus-candidate-info text-left my-1"
        >
          {{ voteItem.submissionText }}
        </div>

        <div class="flex text-chplus-s text-color-candidate font-bold">
          <div class="vote-item-affair-type my-auto">
            {{ voteItem.affair.affairType.name }}
          </div>
          <span
            v-if="voteItem.author || voteItem.divisionText"
            class="my-auto pl-1 pr-1"
            >|</span
          >
          <div v-if="voteItem.author" class="vote-item-author my-auto pr-1">
            {{ voteItem.author }}
          </div>
          &nbsp;
          <div
            v-if="voteItem.divisionText"
            class="vote-item-division-state rounded pl-2 pr-2 my-auto"
            style="border-width: 0.125rem"
          >
            {{ voteItem.divisionText }}
          </div>
        </div>
        <div class="text-chplus-s text-left">
          {{ formattedDate }}
        </div>
        <div
          class="vote-item-description cut-paragraph-3 text-left text-color-candidate text-chplus-candidate-info font-medium "
        >
          {{ voteItem.affair.excerpt }}
        </div>
      </div>
      <vote-result class="mt-2" :result="votePercentageCount" />
    </div>
  </div>
</template>
<script>
// Utilities
import dayjs from "dayjs";
import { mapGetters, mapMutations } from "vuex";
import { VoteMixin } from "@/utils/VoteMixin";

// Components
import VoteItemTag from "@/components/vote/VoteItemTag.vue";
import VoteResult from "./VoteResult.vue";
import PurePinButton from "../buttons/PurePinButton.vue";
import VoteButton from "./VoteButton.vue";

export default {
  name: "VoteItem",
  components: {
    VoteItemTag,
    VoteResult,
    PurePinButton,
    VoteButton
  },
  mixins: [VoteMixin],
  props: {
    voteItem: {
      type: Object,
      required: true
    },
    candidateId: {
      type: Number
    },
    userVote: {
      type: String
    },
    pinnedColor: {
      type: String,
      required: false
    },
    noPinnedHighlight: {
      type: Boolean,
      default: false
    },
    showPin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("viewState", ["voteTagDisplay"]),
    yesCount() {
      const count = this.voteItem.counts.find(count => count.type == 1);

      return count ? count.count : 0;
    },
    noCount() {
      const count = this.voteItem.counts.find(count => count.type == 2);

      return count ? count.count : 0;
    },
    otherVoteCount() {
      return this.voteItem.counts
        .filter(count => count.type != 1 && count.type != 2)
        .reduce((sum, count) => sum + count.count, 0);
    },
    votePercentageCount() {
      return {
        yes: {
          count: this.yesCount,
          percentage: this.voteItem.votePercents.yes
        },
        no: {
          count: this.noCount,
          percentage: this.voteItem.votePercents.no
        },
        other: {
          count: this.otherVoteCount,
          percentage: this.voteItem.votePercents.other
        }
      };
    },
    formattedDate() {
      return dayjs(this.voteItem.date).format("DD.MM.YYYY");
    }
  },
  methods: {
    ...mapMutations("viewState", ["toggleVoteTagDisplay"])
  }
};
</script>
<style lang="scss" scoped>
.vote-item-title {
  font-weight: bold;
}
.vote-item-affair-type,
.vote-item-author {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.vote-item {
  border-width: 6px;
  border-color: var(--highlight);
  border-radius: 1rem;
  background-color: white;
}

.cut-paragraph-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.vote-item-user-vote {
  padding: 0.3rem;
}
@media (min-width: 768px) {
  .vote-item-user-vote {
    padding: 0.43rem;
  }
}
</style>
